import { Table } from '@mui/material';

import { GDMTableComponent } from './GDMTable.type';

/* TODO: Implement component using GDM default design */
const GDMTable: GDMTableComponent = props => <Table {...props} />;

export default GDMTable;
